export const ADD_STELLAR_URL = 'ADD_STELLAR_URL'
export const ADD_LOADING_MESSAGE = 'ADD_LOADING_MESSAGE'
